<template>
  <VDialog width="500" v-model="dialog">
    <v-card>
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle>{{ $t("writeOffProduct") }}</VCardTitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="py-2">
              <CustomInputText
                :label="$t('count')"
                rules="required"
                v-model="writeOffProduct.count"
                class="user_input no-margin"
              ></CustomInputText>
            </div>
            <div class="py-2">
              <CustomTextTextarea
                :label="$t('comment')"
                class="user_input"
                v-model="writeOffProduct.comment"
              ></CustomTextTextarea>
            </div>
            <ValidationProvider
              tag="div"
              class="py-2"
              :name="$t('file')"
              rules="required|document"
              v-slot="{ errors }"
            >
              <VFileInput
                v-model="writeOffProduct.file"
                :error-messages="errors[0]"
                :label="$t('attachFile') + '*'"
              ></VFileInput>
            </ValidationProvider>
            <div class="text-right">
              <VBtn type="submit" color="primary" :loading="loading">{{
                $t("save")
              }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </v-card>
  </VDialog>
</template>

<script>
import { insertDataToFormData } from "@/utils/pureFunctions";

const DEFAULT_WRITE_OFF_PRODUCT_DATA = {
  count: null,
  comment: null,
  file: null,
  productItemId: null,
};
export default {
  name: "WriteOffProductDialog",
  data() {
    return {
      loading: false,
      dialog: false,
      writeOffProduct: {
        ...DEFAULT_WRITE_OFF_PRODUCT_DATA,
      },
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    open(productItemId) {
      this.writeOffProduct.productItemId = productItemId;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    clear() {
      const { formObs } = this.$refs;
      this.writeOffProduct = {
        ...DEFAULT_WRITE_OFF_PRODUCT_DATA,
      };
      if (formObs) formObs.reset();
    },
    async submit() {
      try {
        this.loading = true;
        const formData = insertDataToFormData(this.writeOffProduct);
        await this.$http.post("product-item/use-product-item", formData);
        this.$emit("saved");
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.dialog = false;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
